<template>
  <div>
    <div class="breadcrumb">
      <span>当前位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>设置</el-breadcrumb-item>
        <el-breadcrumb-item>底图设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="search-box">
      <el-button type="primary" size="small" @click="addMapVisible = true"
        >添加底图</el-button
      >
      <el-input
        placeholder="请输入底图名称"
        v-model="inputValue"
        style="width: 300px; float: right"
        clearable
        @clear="search"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="search()"
        ></el-button>
      </el-input>
    </div>
    <div>
      <el-table
        :data="tableData"
        style="width: 100%"
        height="calc(100vh - 295px)"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column
          prop="layerName"
          label="底图名称"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="thumb" label="缩略图" width="180" align="center">
          <template slot-scope="scope">
            <img
              :src="scope.row.thumb"
              style="width: 65px; height: 45px"
              v-if="scope.row.thumb != null"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="url"
          label="服务地址"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column prop="mapDefault" label="默认底图" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.mapDefault == 1 ? "是" : "否" }}</span>
          </template></el-table-column
        >
        <el-table-column prop="tileLayerType" label="服务类型" align="center">
        </el-table-column>
        <el-table-column prop="gridSet" label="格网集" align="center">
        </el-table-column>
        <el-table-column prop="mimeType" label="瓦片格式" align="center">
        </el-table-column>
        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="scope">
            <el-button
              size="small"
              plain
              type="primary"
              @click="setDefaultMap(scope.row.baseMapId)"
              v-if="scope.row.mapDefault == 0"
              >默认底图</el-button
            >
            <el-button
              size="small"
              plain
              type="primary"
              @click="cancelDefaultMap(scope.row.baseMapId)"
              :disabled="scope.row.baseMapId === 18"
              v-else
              >取消默认</el-button
            >
            <el-button
              size="small"
              plain
              type="primary"
              :disabled="scope.$index === 0 || scope.$index === 1"
              @click="moveUpOrDown(scope.row.baseMapId, 0)"
              >上移</el-button
            >
            <el-button
              size="small"
              plain
              type="primary"
              :disabled="scope.$index === 0 || scope.$index === tableData.length - 1"
              @click="moveUpOrDown(scope.row.baseMapId, 1)"
              >下移</el-button
            >
            <el-button
              size="small"
              plain
              type="primary"
              @click="delectRow(scope.row.baseMapId)"
              :disabled="scope.row.mapDefault == 2"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 20px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        popper-class="page-select"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="添加底图"
      :visible.sync="addMapVisible"
      width="600px"
      class="dialog-demo"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="ruleForm-demo"
      >
        <el-form-item label="底图名称：" prop="name">
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入底图名称"
            style="width: 220px"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务类型：" prop="ogcType">
          <el-select
            v-model="ruleForm.ogcType"
            placeholder="请选择服务类型"
            popper-class="form-select"
            clearable
          >
            <el-option label="WMTS" value="WMTS"></el-option>
            <el-option label="TMS" value="TMS"></el-option>
            <el-option label="WMS" value="WMS"></el-option>
            <el-option label="XYZ" value="XYZ"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="瓦片格式：" prop="mimeType">
          <el-select
            v-model="ruleForm.mimeType"
            placeholder="请选择瓦片格式"
            popper-class="form-select"
            clearable
          >
            <el-option label="PNG" value="PNG"></el-option>
            <el-option label="JPEG" value="JPEG"></el-option>
            <el-option label="Webp" value="Webp"></el-option>
            <el-option label="PBF" value="PBF"></el-option>
            <el-option label="TIFF" value="TIFF"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="格网集：" prop="gridSet">
          <el-select
            v-model="ruleForm.gridSet"
            placeholder="请选择格网集"
            popper-class="form-select"
            clearable
          >
            <el-option label="EPSG:4326" value="EPSG:4326"></el-option>
            <el-option label="EPSG:3857" value="EPSG:3857"></el-option>
            <el-option label="EPSG:4490" value="EPSG:4490"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务地址：" prop="url">
          <el-input
            v-model="ruleForm.url"
            placeholder="请输入服务地址"
            style="width: 380px"
          ></el-input>
          <div class="tip">
            示例：http://icenter.geovis.online/tilecache/service/wmts
          </div>
        </el-form-item>
        <el-form-item label="缩略图：" prop="file"
          ><el-upload
            class="upload-demo"
            drag
            action=""
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            accept=".png,.jpg,.jpeg"
          >
            <i class="el-icon-upload" v-if="ruleForm.file == null"></i>
            <img :src="imageUrl" style="width: 100%; height: 100%" v-else />
            <div class="el-upload__tip" slot="tip">
              注：上传支持PNG、JPEG格式，最大不超过10MB；
              <br />图片尺寸应为130*90或13:9均可，系统将等比压缩为130*90大小;
              <br />非13:9图片上传之后可能会被拉伸，影响展示效果。
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm" type="primary" plain size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="addBaseMap" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  addBaseMapSetting,
  baseMapSettingDefault,
  cancelBaseMapSettingDefault,
  deleteBaseMapSetting,
  getBaseMapSettingDefault,
  getBaseMapSettings,
  baseMapSettingUpAndDown,
} from "@/api/baseMap";
export default {
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      total: 0,
      inputValue: "",
      tableData: [],
      addMapVisible: false,
      ruleForm: {
        name: "",
        ogcType: "",
        mimeType: "",
        gridSet: "",
        url: "",
        file: null,
      },
      rules: {
        name: [
          { required: true, message: "请输入底图名称", trigger: "blur" },
          { min: 2, max: 6, message: "长度在 2 到 6 个字符", trigger: "blur" },
        ],
        ogcType: [
          { required: true, message: "请选择服务类型", trigger: "change" },
        ],
        mimeType: [
          { required: true, message: "请选择瓦片格式", trigger: "change" },
        ],
        gridSet: [
          { required: true, message: "请选择格网集", trigger: "change" },
        ],
        url: [{ required: true, message: "请输入服务地址", trigger: "blur" }],
        file: [{ required: true, message: "请上传缩略图", trigger: "change" }],
      },
      imageUrl: "",
    };
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    //取消默认底图
    cancelDefaultMap(baseMapId) {
      if(baseMapId === 18){
        return ;
      }
      let dafaultMap = this.getBaseMapDefaultList();
      if (dafaultMap.length == 1) {
        this.$message.warning("请至少保留一个默认底图！");
        return false;
      }
      cancelBaseMapSettingDefault(baseMapId)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success("取消默认底图成功");
            this.getDataList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //设置默认底图
    async setDefaultMap(baseMapId) {
      let dafaultMap = await this.getBaseMapDefaultList();
      if (dafaultMap.length >= 4) {
        this.$message.warning("系统已有4个默认底图，请先取消一个默认底图！");
        return false;
      }
      baseMapSettingDefault(baseMapId)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success("设置默认底图成功");
            this.getDataList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //获取默认底图
    async getBaseMapDefaultList() {
      let dafaultMap = await getBaseMapSettingDefault();
      return dafaultMap.data;
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getDataList();
    },

    //上移或下移
    moveUpOrDown(baseMapId, upOrDown) {
      let params = {};
      params.baseMapId = baseMapId;
      params.upDown = upOrDown;
      baseMapSettingUpAndDown(params)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success(upOrDown == 0 ? "上移成功" : "下移成功");
            this.getDataList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //取消添加底图
    resetForm() {
      this.addMapVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    //添加底图
    addBaseMap() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = new FormData();
          if (this.ruleForm.file != null) {
            params.append("thumbFile", this.ruleForm.file);
          }

          params.append("gridSet", this.ruleForm.gridSet);
          params.append("layerName", this.ruleForm.name);
          params.append("tileLayerType", this.ruleForm.ogcType);
          params.append("mimeType", this.ruleForm.mimeType);
          params.append("url", this.ruleForm.url);

          addBaseMapSetting(params)
            .then((res) => {
              if (res.status == 200) {
                this.$message.success("添加底图成功");
                this.addMapVisible = false;
                this.getDataList();
                this.resetForm();
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((err) => {
              this.$message.error(err);
            });
        }
      });
    },
    //获取列表
    getDataList() {
      let params = {};
      params.keyWords = this.inputValue;
      params.pageSize = this.pageSize;
      params.pageNum = this.currentPage;
      getBaseMapSettings(params)
        .then((res) => {
          if (res.status == 200) {
            this.tableData = res.data.content;
            this.total = res.data.totalElements;
            this.tableData.forEach(async (element) => {
              if (element.thumb != null) {
                element.thumb = "data:image/png;base64," + element.thumb;
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDataList();
    },
    //上传文件之前的校验
    beforeAvatarUpload(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message.warning("请上传png或者jpg格式图片");
        return false;
      }
      const is10M = file.size / 1024 / 1024 < 10;
      if (!is10M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return false;
      }
      this.imageUrl = URL.createObjectURL(file);
      this.ruleForm.file = file;
      return false;
    },
    //删除
    delectRow(baseMapId) {
      this.$confirm("删除之后将无法恢复，请谨慎操作！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "cancel-button",
        confirmButtonClass: "confirm-button",
        type: "warning",
      }).then(() => {
        deleteBaseMapSetting(baseMapId)
          .then((res) => {
            if (res.status == 200) {
              if (this.currentPage != 1 && this.tableData.length === 1) {
                this.currentPage -= 1;
              }
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getDataList();
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  margin: 20px 0;
}
.tip {
  line-height: 25px;
  color: #c2c6cd;
  font-size: 12px;
}
::v-deep.upload-demo {
  .el-upload-dragger {
    width: 220px;
    height: 152px;
    background: #dde4ea;
  }
  .el-upload-dragger .el-icon-upload {
    margin-top: 45px;
    color: #a5b0b7;
  }
  .el-upload__tip {
    margin-top: 0;
    color: #c2c6cd;
    line-height: 22px;
  }
}
::v-deep.el-table--scrollable-y
  .el-table__body-wrapper::-webkit-scrollbar-track-piece {
  background: #fff;
}
</style>